export default {
    name: 'ContributionSelector',
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    setup() {}
}
